import {
  translateRoomAmenityByLocale,
  translateSpaceAmenityByLocale,
} from "../../constants/space-amenities-translations";
import { formatAddressShort } from "../utils";
import type { RankedSpace } from "../../ai-mode/types";
import { useProposalT } from "../i18n/ProposalI18nContext";

interface AmenitiesTabProps {
  selectedSpace: RankedSpace;
  displayName: string;
  /** Which amenity set to show: the private office (room) or the building. */
  scope?: "office" | "space";
}

export function AmenitiesTab({
  selectedSpace,
  displayName,
  scope = "office",
}: AmenitiesTabProps) {
  const { t, locale } = useProposalT();
  const amenities =
    scope === "space"
      ? (selectedSpace.spaceAmenities ?? [])
      : (selectedSpace.amenities ?? []);
  const translate =
    scope === "space"
      ? translateSpaceAmenityByLocale
      : translateRoomAmenityByLocale;

  return (
    <div
      role="tabpanel"
      className="rounded-2xl overflow-hidden"
      style={{ border: "1px solid #E8E6E3", background: "white" }}
    >
      <div
        className="flex items-center justify-between"
        style={{ padding: "20px 32px 16px" }}
      >
        <div>
          <span className="text-lg font-bold" style={{ color: "#1A1814" }}>
            {displayName}
          </span>
          {selectedSpace.address && (
            <span
              className="text-sm"
              style={{ color: "#78736D", marginLeft: "8px" }}
            >
              {formatAddressShort(selectedSpace.address)}
            </span>
          )}
        </div>
      </div>
      <div
        style={{ height: "380px", overflowY: "auto", padding: "0 32px 28px" }}
      >
        {amenities.length > 0 ? (
          <div
            className="grid grid-cols-1 sm:grid-cols-2"
            style={{ gap: "10px 24px" }}
          >
            {amenities.map((amenity, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "8px 0",
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#22C55E"
                  strokeWidth="2.5"
                  style={{ flexShrink: 0 }}
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
                <span style={{ fontSize: "14px", color: "#555" }}>
                  {translate(amenity, locale)}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm" style={{ color: "#9E9A94" }}>
            {t("amenities.notAvailable")}
          </p>
        )}
      </div>
    </div>
  );
}
